module.exports = __webpack_public_path__ + "img/Virgin-Islands.b7c9b7e5.png";